import { CHAIN_IDS, ChainName, NATIVE_TOKEN_ADDRESS } from '@src/configs/chainInfo'
import { machProtocolAPI } from '@src/libs/MachProtocol'
import { IAllBalancesResponse, IBalanceResponse } from '@src/types/balance'
import {
    IAllAssetsResponse,
    IAssestByChainNameResponse,
    IAssetDataResponse,
    IPricesResponse,
} from '@src/types/machprotocol.api'

export const apiGetAllUSDPrices = async (): Promise<IPricesResponse[]> => {
    const { data } = await machProtocolAPI.get<IPricesResponse[]>('/prices')
    return data
}

export const apiGetAllTokens = async (): Promise<IAllAssetsResponse> => {
    const { data } = await machProtocolAPI.get<IAllAssetsResponse>('/assets')
    return data
}

export const apiGetAllTokensForNetwork = async (networkName: string): Promise<IAssestByChainNameResponse> => {
    const { data } = await machProtocolAPI.get<IAssestByChainNameResponse>(`/assets/${networkName}`)
    return data
}

export const apiGetToken = async (networkName: string, address: string): Promise<IAssetDataResponse> => {
    const { data } = await machProtocolAPI.get<IAssetDataResponse>(`/assets/${networkName}/${address}`)
    return data
}

export const apiGetUserBalanceForToken = async (
    wallet: string,
    networkName: string,
    tokenAddress: string
): Promise<IBalanceResponse> => {
    const { data } = await machProtocolAPI.get<IBalanceResponse>(
        `/users/${wallet}/assets/${networkName}/${tokenAddress === NATIVE_TOKEN_ADDRESS[CHAIN_IDS[networkName as ChainName]] ? 'native' : tokenAddress}`
    )

    return data
        ? {
              ...data,
              address:
                  data.address === 'native' ? NATIVE_TOKEN_ADDRESS[CHAIN_IDS[networkName as ChainName]] : data.address,
          }
        : data
}

export const apiGetUserBalancesForChain = async (wallet: string, networkName: string): Promise<IBalanceResponse[]> => {
    const { data } = await machProtocolAPI.get<IBalanceResponse[]>(`/users/${wallet}/assets/${networkName}`)
    // Replace native with nulladdress
    return data.map((t: IBalanceResponse) =>
        t.address === 'native' ? { ...t, address: NATIVE_TOKEN_ADDRESS[CHAIN_IDS[networkName as ChainName]] } : t
    )
}

export const apiGetUserBalances = async (wallet: string): Promise<IBalanceResponse[]> => {
    const { data } = await machProtocolAPI.get<IAllBalancesResponse>(`/users/${wallet}/assets`)

    // Replace native with nulladdress for all networks
    let returnData: IBalanceResponse[] = []
    for (const networkName of Object.keys(data)) {
        returnData = returnData.concat(
            data[networkName].map((t: IBalanceResponse) =>
                t.address === 'native'
                    ? { ...t, address: NATIVE_TOKEN_ADDRESS[CHAIN_IDS[networkName as ChainName]] }
                    : t
            )
        )
    }

    return returnData
}
